var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcn31(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.06327 8.81442C6.61394 8.81442 6.24994 8.45042 6.24994 8.00109C6.24994 7.55176 6.61394 7.18776 7.06327 7.18776C7.51261 7.18776 7.87661 7.55176 7.87661 8.00109C7.87661 8.45042 7.51261 8.81442 7.06327 8.81442ZM12.4153 5.39842C11.2613 6.38042 10.3879 7.18776 8.90727 7.64976C8.79661 7.09242 8.45127 6.63309 7.98127 6.36976L7.97194 6.36509C8.54927 4.87776 8.94794 2.88776 8.63461 1.94842C8.16927 0.551757 6.65661 -0.561576 3.74661 0.302424C0.553941 1.25109 0.257941 3.99909 2.13394 4.66642C3.56327 5.17509 4.70194 5.52709 5.84261 6.58242C5.43994 6.92576 5.18661 7.43309 5.18461 7.99976C5.18461 8.01042 5.18794 8.02042 5.18794 8.03109C3.61194 8.27576 1.69327 8.92509 1.03727 9.66509C0.0612746 10.7664 -0.148059 12.6331 2.05594 14.7211C4.47327 17.0111 7.00127 15.8938 6.64127 13.9358C6.36661 12.4431 6.10194 11.2811 6.44594 9.76642C6.62927 9.83509 6.84127 9.87642 7.06261 9.87842H7.06394C7.41994 9.87776 7.75261 9.77709 8.03527 9.60242L8.02727 9.60709C9.02661 10.8498 10.5499 12.1898 11.5193 12.3878C12.9619 12.6831 14.6826 11.9304 15.3886 8.97776C16.1633 5.73842 13.9313 4.10776 12.4159 5.39842H12.4153Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcn31);
export default __webpack_public_path__ + "static/media/CCN31.87215f72f30589a9657cad5309f86e8c.svg";
export { ForwardRef as ReactComponent };